<svelte:options customElement="hb-layout-desktop" />

<script lang="ts">
  /**
   * Svelte Video Gallery WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import pkg from "../../../package.json";

  import type { Events as OffcanvasEvents } from "../offcanvas/types/webcomponent.type";
  import type { Events as NavbarEvents } from "../navbar/types/webcomponent.type";
  import type { Events as FooterEvents } from "../footer/types/webcomponent.type";
  import type { Events as SidebarDesktopEvents } from "../sidebar-desktop/types/webcomponent.type";

  import type { Component } from "./types/webcomponent.type";
  import parseStyle from "style-to-object";

  import { styleSetup as footerStyleSetup } from "../footer/extra/docs";
  import { styleSetup as navbarStyleSetup } from "../navbar/extra/docs";
  import { styleSetup as cookieLawBannerStyleSetup } from "../cookie-law-banner/extra/docs";
  import { styleSetup as sidebarDesktopStyleSetup } from "../sidebar-desktop/extra/docs";
  import {
    addComponent,
    getChildStyleToPass,
    LanguageTranslator,
  } from "wc-js-utils";

  let {
    id = "",
    // style = "",
    footer = { type: "auto", disable_expanding_small: false },
    cookielawuri4more = "",
    cookielawallowdecline = false,
    cookielawlanguage = "",
    pagename = undefined,
    cookielaw = undefined,
    onescreen = undefined,
    sidebar = undefined,
    socials = undefined,
    navlinks = undefined,
    contacts = undefined,
    columns = undefined,
    usermenu = undefined,
    i18nlang = undefined,
    page_title = undefined,
    policies = undefined,
    company = undefined,
  }: Component = $props();

  // let translator: LanguageTranslator;

  let parsedStyle: { [x: string]: string } = $state({});

  let footerStyleToSet: string = $state("");
  let navbarStyleToSet: string = $state("");
  let cookieLawBannerStyleToSet: string = $state("");
  let sidebarDesktopStyleToSet: string = $state("");

  let navopen: boolean = $state(true);
  let screensize: string = $state("");

  $effect(() => {
    if (navopen !== true && navopen !== false) navopen = true;
    // if (style) {
    //   parsedStyle = parseStyle(style) as any;
    //   footerStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     footerStyleSetup?.vars
    //   );
    //   navbarStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     navbarStyleSetup?.vars
    //   );
    //   cookieLawBannerStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     cookieLawBannerStyleSetup?.vars
    //   );
    //   sidebarDesktopStyleToSet =
    //     sidebarDesktopStyleToSet +
    //     getChildStyleToPass(parsedStyle, sidebarDesktopStyleSetup?.vars);
    // }
    if (typeof footer === "string") footer = JSON.parse(footer);
    if (!footer.type) footer.type = "auto";

    if (typeof onescreen === "string") {
      if (onescreen !== "no") onescreen = true;
      else onescreen = false;
    } else if (!onescreen) {
      onescreen = false;
    }

    if (!sidebar) sidebar = {};
    else if (typeof sidebar === "string") {
      sidebar = JSON.parse(sidebar);
    }
    if (!company) {
      company = null;
    } else if (typeof company === "string") {
      company = JSON.parse(company as unknown as string);
    }

    screensize = onescreen
      ? "display: flex;flex-direction: column;	height: calc(100vh - 50px);"
      : "display:block;";
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  addComponent({ repoName: "@htmlbricks/hb-footer", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-offcanvas", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-navbar", version: pkg.version });
  addComponent({
    repoName: "@htmlbricks/hb-cookie-law-banner",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-sidebar-desktop",
    version: pkg.version,
  });
  // addComponent({ repoName: "@htmlbricks/hb-sidebar-desktop", version: pkg.version });

  function openmenu(o: OffcanvasEvents["offcanvasswitch"]) {
    console.log("burgerclick", o);
    navopen = o.isOpen;
    // handleResize();

    dispatch("offcanvasswitch", o);
  }
  let a = 0;

  // function detectSize() {
  // 	console.log("resize");
  // 	const c = $host()?.shadowRoot?.querySelector("#container");
  // 	const s = $host()?.shadowRoot?.querySelector("#sidebarcontainer");
  // 	const pageHeight = c.offsetHeight;
  // 	const intFrameHeight = window.innerHeight; // or

  // 	s.style.height = pageHeight + "px";
  // 	s.style.minHeight = intFrameHeight - 50 + "px";
  // }

  // onMount(() => {
  // 	handleResize();
  // });
</script>

{#if navlinks?.length && navopen === true}
  <div id="desktop">
    <hb-navbar
      id="navbar"
      part="navbar"
      noburger={navlinks?.length ? "" : "no"}
      style={navbarStyleToSet}
      companybrandname={page_title || company?.siteName || ""}
      usermenu={usermenu || ""}
      switchopen={navopen ? "yes" : "no"}
      onnavmenuswitch={(el: { detail: NavbarEvents["navmenuswitch"] }) =>
        openmenu(el.detail)}
      onnavbarDropDownClick={(el: {
        detail: NavbarEvents["navbarDropDownClick"];
      }) => dispatch("navbarDropDownClick", el.detail)}
      onnavbarSlotClick={(l: { detail: NavbarEvents["navbarSlotClick"] }) =>
        dispatch("navbarSlotClick", l.detail)}
    >
      <span slot="left-slot">
        <!-- <span
			onclick={() => {
				navopen = !navopen;
			}}>burger</span
		> -->
        {#if company?.logoUri}
          <img
            alt=""
            style="max-height: 31px;vertical-align: middle;"
            src={company.logoUri}
          />
        {/if}
        {#if sidebar?.title}
          {sidebar.title}
        {/if}
      </span>

      <span slot="center-slot"><slot name="nav-center-slot" /></span>
      <span slot="right-slot"><slot name="nav-right-slot" /></span>
    </hb-navbar>

    <div id="layout_container" style="grid-template-columns: 240px auto;">
      <div id="layout_sidebar">
        <div id="inner_sidebar">
          <hb-sidebar-desktop
            id="sidebarcontainer"
            onpageChange={(e: { detail: SidebarDesktopEvents["pageChange"] }) =>
              dispatch("pageChange", e.detail)}
            style={sidebarDesktopStyleToSet}
            navlinks={navlinks || "[]"}
            navpage={pagename || ""}
          ></hb-sidebar-desktop>
        </div>
      </div>
      <div style={screensize} part="container">
        <div style={onescreen ? "flex: 2" : ""} part="page" id="page">
          <slot name="page">page</slot>
        </div>
        {#if cookielaw || cookielawallowdecline || cookielawlanguage || cookielawuri4more}
          <hb-cookie-law-banner
            style={cookieLawBannerStyleToSet}
            language={cookielawlanguage || i18nlang}
            allowdecline={cookielawallowdecline}
            {cookielawuri4more}
          ></hb-cookie-law-banner>
        {/if}
        <hb-footer
          {policies}
          type={footer.type === "auto"
            ? onescreen
              ? "small"
              : "regular"
            : footer.type}
          disable_expanding_small={footer.disable_expanding_small
            ? "yes"
            : "no"}
          part="footer"
          socials={socials ? JSON.stringify(socials) : ""}
          contacts={contacts ? JSON.stringify(contacts) : ""}
          style="display:block;{footerStyleToSet}"
          company={company ? JSON.stringify(company) : ""}
          columns={columns || ""}
          onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
            dispatch("footerClick", el.detail)}
        ></hb-footer>
      </div>
    </div>
  </div>
{:else}
  <div id="desktop_without_sidebar">
    <hb-navbar
      id="navbar"
      part="navbar"
      noburger={navlinks?.length ? "" : "no"}
      style={navbarStyleToSet}
      companybrandname={page_title || company?.siteName || ""}
      usermenu={usermenu || ""}
      switchopen={navopen ? "yes" : "no"}
      onnavmenuswitch={(el: { detail: NavbarEvents["navmenuswitch"] }) =>
        openmenu(el.detail)}
      onnavbarDropDownClick={(el: {
        detail: NavbarEvents["navbarDropDownClick"];
      }) => dispatch("navbarDropDownClick", el.detail)}
      onnavbarSlotClick={(l: { detail: NavbarEvents["navbarSlotClick"] }) =>
        dispatch("navbarSlotClick", l.detail)}
    >
      <span slot="left-slot">
        <!-- <span
			onclick={() => {
				navopen = !navopen;
			}}>burger</span
		> -->
        {#if company?.logoUri}
          <img
            alt=""
            style="max-height: 31px;vertical-align: middle;"
            src={company.logoUri}
          />
        {/if}
        {#if sidebar?.title}
          {sidebar.title}
        {/if}
      </span>

      <span slot="center-slot"><slot name="nav-center-slot" /></span>
      <span slot="right-slot"><slot name="nav-right-slot" /></span>
    </hb-navbar>
    <div>
      <div style={screensize} part="container">
        <div style={onescreen ? "flex: 2" : ""} part="page" id="page">
          <slot name="page">page</slot>
        </div>
        {#if cookielaw || cookielawallowdecline || cookielawlanguage || cookielawuri4more}
          <hb-cookie-law-banner
            style={cookieLawBannerStyleToSet}
            language={cookielawlanguage || i18nlang}
            allowdecline={cookielawallowdecline}
            {cookielawuri4more}
          ></hb-cookie-law-banner>
        {/if}
        <hb-footer
          {policies}
          type={footer.type === "auto"
            ? onescreen
              ? "small"
              : "regular"
            : footer.type}
          disable_expanding_small={footer.disable_expanding_small
            ? "yes"
            : "no"}
          part="footer"
          socials={socials ? JSON.stringify(socials) : ""}
          contacts={contacts ? JSON.stringify(contacts) : ""}
          style="display:block;{footerStyleToSet}"
          company={company ? JSON.stringify(company) : ""}
          columns={columns || ""}
          onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
            dispatch("footerClick", el.detail)}
        ></hb-footer>
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  // @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
  #desktop_without_sidebar {
    min-height: 100vh;
  }
  #desktop {
    min-height: 100vh;
    display: grid;
    grid-template-rows: max-content auto;
  }
  #layout_container {
    display: grid;
  }

  #layout_sidebar {
    width: 240px;
    grid-row-start: 1;
    grid-row-end: 1;
    display: flex;
    position: relative;
  }
  #inner_sidebar {
    position: absolute;
    height: 100%;
  }
  hb-sidebar-desktop {
    height: 100%;
  }
</style>
